module.exports = __webpack_public_path__ + "static/media/manzanilla-pack.6c908714.png";